import _ from 'lodash';
import transformInstructions from './instructionsCurriculum';

let curriculum = {};

export const setCurriculum = (c) => { curriculum = c; };

let audioMap = {};

export const setAudioMap = (a) => {
  audioMap = a;
};

export const getAudioMap = () => audioMap;

export const retrieveQueue = (level, set) => _.shuffle(curriculum.levels[`level_${level}`][`set_${set}`]);

export const retrieveInstructionContent = (category) => {
  const instructionSet = getInstructionSetByCategory(category);
  const {
    categories,
    hard_words,
    soft_words,
    target_cell,
    target_word,
    vowels,
  } = instructionSet;
  return transformInstructions(target_word, categories, target_cell, vowels, soft_words, hard_words);
};

const getInstructionSetByCategory = category => Object.values(curriculum.instruction).find(
  value => value.categories.includes(category),
);

export const retrieveOnboardingQueue = () => curriculum.onboarding.set;
export const retrieveOnboardingCategories = () => curriculum.onboarding.categories;
